/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { QuantityValueType } from './QuantityValueType';
import {
    instanceOfQuantityValueType,
    QuantityValueTypeFromJSON,
    QuantityValueTypeFromJSONTyped,
    QuantityValueTypeToJSON,
} from './QuantityValueType';

/**
 * @type CreateDefinitionDtoValueType
 * 
 * @export
 */
export type CreateDefinitionDtoValueType = QuantityValueType;


export function CreateDefinitionDtoValueTypeFromJSON(json: any): CreateDefinitionDtoValueType {
    return CreateDefinitionDtoValueTypeFromJSONTyped(json, false);
}

export function CreateDefinitionDtoValueTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDefinitionDtoValueType {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...QuantityValueTypeFromJSONTyped(json, true) };
    return  QuantityValueTypeFromJSONTyped(json, true);
}

export function CreateDefinitionDtoValueTypeToJSON(value?: CreateDefinitionDtoValueType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfQuantityValueType(value)) {
        return QuantityValueTypeToJSON(value as QuantityValueType);
    }

    return {};
}

/**
 * Check if a given object implements the CreateDefinitionDtoValueType interface.
 */
export function instanceOfCreateDefinitionDtoValueType(value: any): value is CreateDefinitionDtoValueType {
    if (instanceOfQuantityValueType(value)) return true;
    return false;
}

